import "./CustomTooltip.css";

import * as Tooltip from "@radix-ui/react-tooltip";
import { ReactNode } from "react";
import { Trans } from "react-i18next";

export type CustomTooltipProps = {
  message?: string;
  children: ReactNode;
  hideIfEmpty?: boolean;
  asChild?: boolean;
  sideOffset?: number;
};

const CustomTooltip = ({
  children,
  message,
  hideIfEmpty,
  asChild,
  sideOffset,
}: CustomTooltipProps) => {
  if (!message && hideIfEmpty) return undefined;
  if (!message) return children;
  return (
    <Tooltip.Provider delayDuration={100}>
      <Tooltip.Root>
        <Tooltip.Trigger
          asChild={asChild}
          className="!cursor-default bg-transparent"
        >
          {children}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            sideOffset={sideOffset}
            className="TooltipContent z-[100000] max-w-sm rounded-xl bg-black px-3 py-2 text-center text-sm font-semibold text-white"
          >
            <Trans>{message}</Trans>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default CustomTooltip;
